import { IReportMeasurement, IReportPerson } from "Data";
import { observable } from "mobx";

export class IReportMeasurementGroup {
    id!: string;
    title!: string;
    date!: string;
    clubType!: string;
    tags!: Array<string>;  
    ball!: string;        
    player: IReportPerson | undefined;
    normalStrokes!: Array<IReportMeasurement>;
    normalizedStrokes!: Array<IReportMeasurement>;
    @observable strokes?: Array<IReportMeasurement>;
    @observable isSelected?: boolean;
    @observable isCollapsed?: boolean;    
    abbreviatedClubType: string = "";
    tagsTitle?: string;
    color?: string;
    inYards!: boolean;
    target?: string;
    lengthToTarget?: number;
    targetDefinition?: string;
    averageScore?: number;
    averageDistanceFromPin?: number;
}